<template>
  <YdDialog :visible="visible" append-to-body @close="close" width="40%" :title="title">
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      style="margin-left: 30px; margin-right: 10px"
      size="mini"
      label-position="left"
      label-width="80px"
    >
      <el-form-item label="奖品" prop="prizesId" v-if="prizeType !== 'none'">
        <div v-if="form.type === 4">{{ form.prizeName }}</div>
        <el-select v-model="form.prizesId" v-else placeholder="请选择" @change="changeSelect">
          <el-option
            v-for="item in prizeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        label="奖品库存"
        prop="numbers"
        :rules="form.id ? [{ required: false }] : rules.numbers"
        v-if="prizeType !== 'none' && form.type !== 4"
      >
        <div v-if="!form.id">
          <el-input-number v-model="form.numbers" :controls="false" :min="0" />
          <span class="margin-left-10" v-if="prizeData.length && prizeData[0].prizeType !== 2"
            >数量不可超过（{{ prizeData.length ? prizeData[0].availableNumbers : 0 }}）个</span
          >
        </div>
        <div v-else>
          <el-table :data="prizeData" border size="mini" max-height="280px">
            <el-table-column label="已配置库存" align="center" prop="numbers">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.numbers === 0 ? 0 : scope.row.numbers ? scope.row.numbers : '-' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="实时剩余库存" align="center" prop="remainNumbers">
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.remainNumbers === 0
                      ? 0
                      : scope.row.remainNumbers
                      ? scope.row.remainNumbers
                      : '-'
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="可分配库存" align="center" prop="availableNumbers">
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.availableNumbers === 0
                      ? 0
                      : scope.row.availableNumbers
                      ? scope.row.availableNumbers
                      : '-'
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-row class="margin-top-15 flex flex flex-justify-center flex-align-center">
            <el-col style="width: 100px">
              <el-radio-group v-model="form.inventoryType">
                <el-radio class="margin-top-10" :label="1">加库存</el-radio>
                <el-radio class="margin-top-20" :label="0" :disabled="activeStatus === 2"
                  >减库存</el-radio
                >
              </el-radio-group>
            </el-col>
            <el-col>
              <div>
                <el-input-number
                  v-model="form.numbers"
                  :controls="false"
                  :min="0"
                  style="width: 100px; margin-left: 10px"
                />
                <span
                  v-if="prizeData.length && prizeData[0].prizeType !== 2 && form.type !== 4"
                  class="margin-left-10"
                  >数量不可超过（{{
                    prizeData.length ? prizeData[0].availableNumbers : 0
                  }}）个</span
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
      <el-form-item label="中奖概率" prop="winnerRate">
        <el-input-number v-model="form.winnerRate" :precision="2" :controls="false" :min="0" /> %
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="form.sort" :controls="false" :min="0" />
        <span class="margin-left-10 font-12 color-">数字越大，奖品位置越靠前</span>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="loading">保 存</el-button>
    </div>
  </YdDialog>
</template>

<script>
  import { prizeList, prizeAdd, prizeUpdate } from '@/api/marketing/prize-draw'
  export default {
    name: 'prizeStatistics',
    data() {
      return {
        form: {},
        prizeList: [],
        rules: {
          prizesId: [{ required: true, message: '请选择奖品', trigger: 'change' }],
          numbers: [{ required: true, message: '请输入库存', trigger: 'blur' }],
          winnerRate: [{ required: true, message: '请输入概率', trigger: 'blur' }]
        },
        info: {},
        title: '',
        prizeData: [],
        loading: false
      }
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      prizeType: {
        // prize奖品，none谢谢参与
        type: String,
        default: ''
      },
      activityId: {
        type: String,
        default: ''
      },
      activeStatus: {
        type: String,
        default: ''
      }
    },
    mounted() {
      prizeList().then((res) => {
        if (res.code) return
        res.data.forEach((item) => {
          item.label = item.prizeName
          item.value = item.prizesId
        })
        this.prizeList = res.data
      })
    },
    methods: {
      close() {
        this.form = {}
        this.prizeData = []
        this.$refs.ruleForm.resetFields()
        this.$emit('close')
      },
      init(value) {
        if (value) {
          this.form = value
          this.title = '编辑奖品'
        } else {
          this.title = '新增奖品'
          this.form = {}
        }
        const params = {
          raffleActivityPrizeId: value.id
        }
        prizeList(params).then((res) => {
          if (res.code) return
          res.data.forEach((item) => {
            item.label = item.prizeName
            item.value = item.prizesId
          })
          this.prizeList = res.data
          // 拼接库存表格数据
          this.prizeData = this.getTableData(value.prizesId)
        })
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          // 判断库存，设置谢谢参与不判断
          if (
            this.prizeType !== 'none' &&
            this.prizeData[0].availableNumbers &&
            this.prizeData[0].availableNumbers < this.form.numbers
          ) {
            this.$message.warning('库存不足')
            return
          }
          if (valid) {
            const params = {
              id: this.form.id,
              prizesId: this.form.prizesId,
              sort: this.form.sort,
              winnerRate: this.form.winnerRate * 100,
              raffleActivityId: this.activityId,
              numbers: this.form.id
                ? this.form.inventoryType === 1
                  ? this.form.numbers
                  : -this.form.numbers
                : this.form.numbers
            }
            if (this.prizeType === 'none') {
              params.prizeName = '谢谢参与'
            }
            let result
            this.loading = true
            if (this.form.id) {
              result = await prizeUpdate(params)
            } else {
              result = await prizeAdd(params)
            }
            this.loading = false
            if (result.code) return
            this.$message.success(`${this.form.id ? '修改成功' : '新增成功'}`)
            this.$emit('init')
            this.close()
          } else {
            return false
          }
        })
      },
      getTableData(id) {
        // 获取库存
        const arr = this.prizeList.filter((item) => item.prizesId === id)
        return arr
      },
      changeSelect(e) {
        // 切换奖品
        !this.form.id && (this.form.numbers = 0)
        this.prizeData = this.getTableData(e)
      }
    }
  }
</script>
<style scoped lang="scss">
  .title-box {
    margin: 0 0 20px 10px;
    font-size: 18px;
    font-weight: 500;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }
  .el-radio {
    margin-right: 0 !important;
  }
</style>
